import { put, takeLatest } from 'redux-saga/effects'
import {FETCH_TRENDING_REQUEST, FETCH_TRENDING_SUCCESS} from "../actions"

function* fetch() {
    // Skip fetching from /trending API (GA v3 is deprecated and causing 500s)
    yield put({type: FETCH_TRENDING_SUCCESS, payload: [] });
}

function* fetchTrendingSaga() {
    yield takeLatest(FETCH_TRENDING_REQUEST, fetch);
}

export default fetchTrendingSaga;


// WEBPACK FOOTER //
// ./src/sagas/trending.js